__turbopack_context__.v({
  "border": "Popover-module___z1C6q__border",
  "closeButton": "Popover-module___z1C6q__closeButton",
  "closeButtonAbsolute": "Popover-module___z1C6q__closeButtonAbsolute",
  "contrast": "Popover-module___z1C6q__contrast",
  "default": "Popover-module___z1C6q__default",
  "dialog": "Popover-module___z1C6q__dialog",
  "freeHeight": "Popover-module___z1C6q__freeHeight",
  "minimalPadding": "Popover-module___z1C6q__minimalPadding",
  "overlayArrow": "Popover-module___z1C6q__overlayArrow",
  "popover": "Popover-module___z1C6q__popover",
});
